<template>
  <v-container fluid>
    <PageHeader no-padding />
    <Subheader v-model="search" title="Flags" search="flags">
      <v-btn color="add" @click="clickAdd()">
        <v-icon class="mr-1">add</v-icon>
        {{ $t('Button.Add_Flag') }}
      </v-btn>
    </Subheader>

    <v-card>
      <v-card-text>
        <v-data-table :headers="headers" :items="tenantFlagsList" :pagination.sync="pagination" :search="search">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">
              {{ props.item.FlagCode }}
              <v-icon small color="delete" v-if="!props.item.ShowValues">priority_high</v-icon>
            </td>
            <td class="text-xs-left">{{ props.item.Description }}</td>
            <td class="text-xs-left">{{ props.item.ShowValues ? 'Yes' : 'No' }}</td>
            <td class="text-xs-right">
              <v-flex>
                <v-btn small color="warning" depressed @click="clickEdit(props.item)">
                  <v-icon class="mr-1">edit</v-icon>
                  {{ $t('Button.Edit') }}
                </v-btn>
                <v-btn small color="error" @click="clickDelete(props.item)">
                  <v-icon class="mr-1">delete_forever</v-icon>
                  {{ $t('Button.Delete') }}
                </v-btn>
              </v-flex>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-subheader>
      <v-icon small color="delete">priority_high</v-icon>Results with this flag are hidden in reports, graphs, and
      queries.
    </v-subheader>

    <v-dialog v-model="showAddDialog" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('FlagsManage.addTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="addForm" ref="addForm" lazy-validation style="width: 100%">
          <v-card-text>
            <v-layout>
              <v-flex xs12 pl-3 pr-3>
                <v-text-field label="FlagCode" v-model="flagData.FlagCode"></v-text-field>
                <v-text-field label="Description" v-model="flagData.Description"></v-text-field>
                <v-checkbox v-model="flagData.ShowValues" label="Show Flagged Values"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text class="pt-0">
            <transition name="fade">
              <v-subheader v-if="!flagData.ShowValues">
                <v-icon small color="delete">priority_high</v-icon>Results with this flag are hidden in reports, graphs,
                and queries.
              </v-subheader>
            </transition>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="submitAdd()">
              <v-icon>done</v-icon>
              {{ $t('Button.Create') }}
            </v-btn>
            <v-btn outline color="secondary" @click="closeDialog()">{{ $t('Button.Close') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showUpdateDialog" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('FlagsManage.updateTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="updateForm" ref="updateForm" lazy-validation style="width: 100%">
          <v-card-text>
            <v-layout>
              <v-flex xs12 pl-3 pr-3>
                <v-text-field label="FlagCode" v-model="updateData.FlagCode"></v-text-field>
                <v-text-field label="Description" v-model="updateData.Description"></v-text-field>
                <v-checkbox v-model="updateData.ShowValues" label="Show Flagged Values"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text class="pt-0">
            <transition name="fade">
              <v-subheader v-if="!updateData.ShowValues">
                <v-icon small color="delete">priority_high</v-icon>Results with this flag are hidden in reports, graphs,
                and queries.
              </v-subheader>
            </transition>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="submitUpdate()">
              <v-icon>done</v-icon>
              {{ $t('Button.Save') }}
            </v-btn>
            <v-btn outline color="secondary" @click="closeDialog()">{{ $t('Button.Close') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="comfirmDialog" max-width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('FlagsManage.confirmTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>{{ $t('FlagsManage.confirmTextMsg') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" depressed @click="confirmDelete()">
            <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.Confirm') }}
          </v-btn>
          <v-btn color="secondary" outline @click.native="comfirmDialog = false">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card color="grey lighten-4">
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const guidelines = createNamespacedHelpers('guidelines')
  const admin = createNamespacedHelpers('admin')
  const authenticate = createNamespacedHelpers('authenticate')
  const flags = createNamespacedHelpers('flags')

  export default {
    props: {
      tenant: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        search: '',
        showAddDialog: false,
        showUpdateDialog: false,
        comfirmDialog: false,
        updateData: {},
        deleteData: {},
        snackbar: '',
        snackColor: '',
        snackMessage: '',
        addForm: true,
        updateForm: true,
        flagData: {
          ShowValues: true,
        },
        headers: [{
          text: 'Flag Code',
          value: 'FlagCode',
          align: 'left',
        },
        {
          text: 'Description',
          value: 'Description',
          align: 'left',
        },
        {
          text: 'Show Flagged Values',
          value: 'ShowValues',
          align: 'left',
        },
        {
          text: 'Action',
          value: null,
          align: 'right',
        },
        ],
        pagination: {
          sortBy: 'longName',
          rowsPerPage: 10,
        },
      }
    },
    mounted() {
      this.FetchDate()
    },
    computed: {
      ...guidelines.mapGetters(['Guidelines']),
      ...admin.mapGetters(['roleList']),
      ...authenticate.mapGetters(['currentUserGroup', 'isSystemAdmin', 'isTenantAdmin']),
      ...flags.mapGetters(['flags']),
      roleListString() {
        let data = []
        this.roleList.forEach(e => {
          data.push(e.RoleName)
        })
        return data
      },
      tenantList() {
        return JSON.parse(JSON.stringify(this.roleList))
      },
      tenantFlagsList() {
        let match = this.roleList.find(x => x.RoleName == this.tenant)
        if (match == null) {
          return
        }
        return this.flags.filter(x => x.TenantId == match.Id)
      },
    },
    watch: {
      roleList() {
        this.FetchFlagsDate(this.tenant)
      },
    },
    methods: {
      ...admin.mapActions(['getRoleList']),
      ...flags.mapActions(['getFlagsByTenant', 'addFlag', 'editFlag', 'deleteFlag']),
      clickAdd() {
        this.showAddDialog = true
        this.emptyFlag()
      },
      clickEdit(data) {
        this.showUpdateDialog = true
        this.updateData = JSON.parse(JSON.stringify(data))
      },
      clickDelete(data) {
        this.comfirmDialog = true
        this.deleteData = data
      },
      async FetchDate() {
        if (!this.roleList || !this.roleList.length) {
          await this.getRoleList()
        } else {
          this.FetchFlagsDate(this.tenant)
        }
      },
      FetchFlagsDate(tenant) {
        let match = this.roleList.find(x => x.RoleName == tenant)
        this.getFlagsByTenant(match.Id)
      },
      emptyFlag() {
        this.flagData = {
          ShowValues: true,
        }
      },
      async submitAdd() {
        let options = {
          data: {
            FlagCode: this.flagData.FlagCode,
            Description: this.flagData.Description,
            ShowValues: this.flagData.ShowValues,
            TenantId: this.roleList.find(x => x.RoleName == this.tenant).Id,
          },
          successCb: () => {
            this.snackMessage = this.$t('FlagsManage.addSuccessMsg', {
              msg: this.flagData.FlagCode,
            })
            this.snackColor = 'success'
            this.snackbar = true
            this.closeDialog()
          },
          failedCb: (err) => {
            this.snackMessage = err.response.data.ExceptionMessage
            this.snackColor = 'error'
            this.snackbar = true
          },
        }
        if (this.flagData.FlagCode != null && this.flagData.Description != null) {
          await this.addFlag(options)
        } else {
          this.snackbar = true
          this.snackColor = 'info'
          this.snackMessage = this.$t('FlagsManage.addFailMsg')
        }
        this.emptyFlag()
      },
      submitUpdate() {
        let options = {
          data: {
            Id: this.updateData.Id,
            FlagCode: this.updateData.FlagCode,
            Description: this.updateData.Description,
            ShowValues: this.updateData.ShowValues,
            TenantId: this.updateData.TenantId,
          },
          successCb: () => {
            this.snackMessage = this.$t('FlagsManage.updateSuccessMsg', {
              msg: this.updateData.FlagCode,
            })
            this.snackColor = 'success'
            this.snackbar = true
            this.closeDialog()
          },
          failedCb: (err) => {
            this.snackColor = 'error'
            this.snackMessage = err
            this.snackbar = true
          },
        }
        if (this.updateData.FlagCode != '' && this.updateData.Description != '') {
          this.editFlag(options)
        } else {
          this.snackbar = true
          this.snackColor = 'info'
          this.snackMessage = this.$t('FlagsManage.updateFailMsg')
        }
      },
      confirmDelete() {
        let options = {
          data: {
            Id: this.deleteData.Id,
            FlagCode: this.deleteData.FlagCode,
            Description: this.deleteData.Description,
            ShowValues: this.deleteData.ShowValues,
            TenantId: this.deleteData.TenantId,
          },
          successCb: () => {
            this.snackMessage = this.$t('FlagsManage.deleteSuccessMsg', {
              msg: this.deleteData.FlagCode,
            })
            this.snackColor = 'success'
            this.snackbar = true
            this.closeDialog()
          },
          failedCb: (err) => {
            this.snackColor = 'error'
            this.snackMessage = err
            this.snackbar = true
          },
        }
        this.deleteFlag(options)
        this.comfirmDialog = false
      },
      closeDialog() {
        this.showAddDialog = false
        this.showUpdateDialog = false
        this.comfirmDialog = false
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    /* .fade-leave-active below version 2.1.8 */
    opacity: 0;
  }

  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }
</style>